import React, { useEffect, useState, useRef } from "react";
import {  useNavigate } from "react-router-dom";
import Switch from "@mui/material/Switch";
import TelegramWidget from "../../components/widget/telegramWidget";
import "../../App.css";
import { BASE_URL } from "../../utils/config";
import FutureSection from "../../components/futuresectionMCX";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Container from "react-bootstrap/Container";
import { styled } from "@mui/material/styles";

import Loading from "../../components/loading";
import Sidebar from "../../components/sidebar";
import Report from "../report";

const CreateReport = () => {
    const navigate = useNavigate();
    const [eventForm, setEventForm] = useState({
        eventType: "Future",
    });

    const imageRef = useRef();
    const [imageName, setImageName] = useState(null);
    const [checked, setChecked] = useState(true);
    const [isFormEditable, setIsFormEditable] = useState(true);
    const [imageUrl, setimageURL] = useState(null);
    const [base64ImageData, setBase64ImageData] = useState("");
    const [reportDate, setReportDate] = useState({});
    const [loading, setLoading] = useState(false);
    const [futureSectionState, setFutureSectionState] = useState({
        futureReportType: "BUY",
        stockType: "",
        cashCMP: "",
        futureCMP: "",
        futureSL: 0,
        futureRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
        commentry: "",
        Expiry: "",
        imageData: "",
        volume: '',
        lot_size: "",
        lot: "",
        margin: ""
    });
    const [FutureExpirySelected, setFutureExpirySelected] = useState([]);
    const [FutureStockSelected, setFutureStockSelected] = useState([]);




    const [stockLossRecord, setStockLossRecord] = useState({});
    const [stockSymbols, setStockSymbols] = useState([]);
 
    const [commenteryData, setCommenteryData] = useState([]);
    const [request_token, setRequestToken] = useState("");

    const [errorDialog, setErrorDialog] = useState(false);
    const [futureError, setFutureError] = useState(false);
  
    const [ApiError, setApiError] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
  
    const [RoleType, setRoleType] = useState('');
    const [alreadySubmit, setAlreadySubmit] = useState(false)
    const [imageGenerate, setImageGenerate] = useState(false)
    let count = 0;
    useEffect(() => {
        if (count === 0) {

            let roleType = JSON.parse(localStorage.getItem('roleType'));
            // console.log("roleType in side",roleType)
            setRoleType(roleType);
            if (roleType === 'User') {
                setEventForm({ ...eventForm, eventType: "HNI" });
                getstock("HNI");
                getcommentery();
                count += 1;
            }
            else {
                getstock("Future");
                getcommentery();
                count += 1;
            }

        }
    }, []);


    //  this function use to handle state data selcection change form child component
    const handleFutureSectionChange = (newFutureState) => {
      
        setFutureSectionState(newFutureState);
    };

      //  this function use to handle expiry record  change form child component
    const handleFutureExpirySelect = (newExpirySelected) => {
        setFutureExpirySelected(newExpirySelected);
    };

      //  this function use to handle stock  change form child component
    const handleFutureStockSelect = (newStockSelected) => {
       
        setFutureStockSelected(newStockSelected);
        setBase64ImageData("");
        setimageURL("");
        setImageGenerate(false)
    };

  


//  this fucntion used to get and show stock list
    const getstock = async (reportType) => {
       try{
        await fetch(`${BASE_URL}/getstockdataforMCX/${reportType}`, {
            method: "GET",
        })
            .then((response) => response.json())
            .then(async (res) => {
                // Process the API response data
                console.log("response of mcx records",res);

                if (res.success === true) {
                    
                    let data = res.delvieryData;
                    
                        setStockSymbols(data);
                        setRequestToken(res.request_token);
                        setLoading(false);
                 
                } else {
                    setLoading(false);
                    setErrorDialog(true);
                    setApiError(true);

                    setTimeout(() => {
                        setErrorDialog(false);
                        setApiError(false);
                    }, 2000);
                }
            })
            .catch((error) => {
                // Handle errors
                setLoading(false);
                setErrorDialog(true);
                setApiError(true);

                setTimeout(() => {
                    setErrorDialog(false);
                    setApiError(false);
                }, 2000);
                console.error("Error fetching data:", error);
            });
        }catch(error){
         
            setLoading(false);
            setErrorDialog(true);
            setApiError(true);

            setTimeout(() => {
                setErrorDialog(false);
                setApiError(false);
            }, 2000);
        }
    };


    //  this function is used to get commentry data 

    const getcommentery = async () => {
        var eventDate = new Date();
        var day = eventDate.getDate();
        var monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        var month = monthNames[eventDate.getMonth()];
        var year = eventDate.getFullYear();

        var formattedDate = day + " " + month + " " + year;
        // console.log("formattedDate", formattedDate);
        let loginuser = JSON.parse(localStorage.getItem("loginData"));
 
        setReportDate(formattedDate);
        try{
        await fetch(`${BASE_URL}/getallcommentery`, {
            method: "GET",
            headers: {
                'Authorization': `Bearer ${loginuser.token}`
              }
        })
            .then((response) => response.json())
            .then((res) => {
               
                console.log(res.commenteryData);

                if (res.success === true) {
                    setCommenteryData(res.commenteryData[0]);
                }else if(res.status === 403){ 
                    setLoading(false)
                    setErrorMessage(`Error: ${res.message}`)
                    setShowError(true);
                    setTimeout(() => {
                      setShowError(false)
                      setErrorMessage("")
                      localStorage.clear()
                      navigate('/login')
                    }, 2000);
                  }
                  else if(res.status === 401){
                    setLoading(false)
                    setErrorMessage(`Error: ${res.message}`)
                    setShowError(true);
                    setTimeout(() => {
                      setShowError(false)
                      setErrorMessage("")
                      localStorage.clear()
                      navigate('/login')
                    }, 2000);
                  }else{
                    setLoading(false)
                    setErrorMessage(`Error: ${res.message}`)
                    setShowError(true);
                    setTimeout(() => {
                      setShowError(false)
                      setErrorMessage("")
                    }, 2000);
                  }
            })
            .catch((error) => {
                // Handle errors
                setLoading(false)
                console.error("Error fetching data:", error);
                setErrorMessage(`Error: ${error.message}`)
                setShowError(true);
                setTimeout(() => {
                  setShowError(false)
                  setErrorMessage("")
                }, 2000);
            });
        }catch(error){
            setLoading(false)
          setErrorMessage(`Error: ${error.message}`)
          setShowError(true);
          setTimeout(() => {
            setShowError(false)
            setErrorMessage("")
          }, 2000);

        }
    };



    //  this fucntion is used to submit the report form to create remote
    const submitForm = async (event) => {
        event.preventDefault();
        setLoading(true);
       
        console.log("futureSectionState===========",futureSectionState)

        if (eventForm.eventType === "Future") {
          
            const futureCMPIsNumeric = /^\d*\.?\d{0,2}$/.test(
                futureSectionState.futureCMP
            );
            const futureSLIsNumeric = /^\d*\.?\d{0,2}$/.test(
                futureSectionState.futureSL
            );
            if (
                futureSectionState.futureCMP === "" ||
                futureSectionState.futureSL === "" ||
                futureSectionState.stockType === "" ||
                futureSectionState.Expiry === "" ||
                futureSectionState.commentry === ""
            ) {
               
                setLoading(false);
                setErrorDialog(true);
                setFutureError(true);

                setTimeout(() => {
                    setErrorDialog(false);
                    setFutureError(false);
                  
                }, 2000);
              
            }
          
          
            else if (!futureCMPIsNumeric) {
             
                setLoading(false);
                setErrorDialog(true);
                setFutureError(true);

                setTimeout(() => {
                    setErrorDialog(false);
                    setFutureError(false);

                   
                }, 2000);
             
            } else if (!futureSLIsNumeric) {
               
                setLoading(false);
                setErrorDialog(true);
                setFutureError(true);

                setTimeout(() => {
                    setErrorDialog(false);
                    setFutureError(false);
                  
                }, 2000);
               
            } else {
                
                setAlreadySubmit(true);
                const matchingStock = stockSymbols.find(
                    (stock) => stock.name === futureSectionState.stockType
                );

                console.log("stock", matchingStock);

                generateReport(matchingStock.name, matchingStock.TVExchange);


            }
        }
        
    };

    //  this function is used to generate the image of a stock 
    const generateReport = async (stock, stockType) => {
        console.log("imageurl",imageUrl,"imageName",imageName)
        if (!imageUrl) {
            console.log("imageGenerate", imageGenerate)
            if (!imageGenerate) {
                console.log("insdie if of generte report");
                try{
                await fetch(`${BASE_URL}/getstockimage/${stock}/${stockType}`, {
                    method: "GET", // or 'POST' or any other HTTP method
                    headers: {
                        Accept: "image/png",
                    },
                    responseType: "blob", // Set the responseType to 'blob'
                })
                    .then((response) => response.arrayBuffer())
                    .then((buffer) => {
                        // console.log("buffer", typeof buffer,buffer)

                        const blob = new Blob([buffer], { type: "image/png" });
                        let imageurl = URL.createObjectURL(blob);
                        setimageURL(imageurl);

                        if (blob) {
                            const uint8Array = new Uint8Array(buffer);
                            const base64String = uint8Array.reduce(
                                (data, byte) => data + String.fromCharCode(byte),
                                ""
                            );
                            const ImageData = btoa(base64String);
                           
                            setBase64ImageData(ImageData)
                             if (eventForm.eventType === "Future") {
                                setLoading(false);
                              
                            }

                            if (eventForm.eventType === "Options") {
                                setLoading(false);
                               
                            }

                            if (eventForm.eventType === "Delivery") {
                                setLoading(false);
                              
                            }
                            if (eventForm.eventType === "HNI") {
                                setLoading(false);
                               
                            }
                        }
                    })
                    .catch((error) =>{ 
                        console.error("Error fetching image:", error)
                        setErrorMessage(`Error: ${error.message}`)
                        setShowError(true)
                         setLoading(false)
                         setTimeout(() => {
                           setShowError(true)
                           setErrorMessage('')
             
                         }, 2000);
                    });
                }catch(error){
                    setErrorMessage(`Error: ${error.message}`)
                    setShowError(true)
                     setLoading(false)
                     setTimeout(() => {
                       setShowError(true)
                       setErrorMessage('')
         
                     }, 2000);  
                }    
            }
        }
        else if (imageName) {
            console.log("insdie else to set image  of generte report",imageName);
            const base64ImageData = imageUrl.split(",")[1];
         
            console.log("image form reader when file selected");
            // setimageURL(image);
            setBase64ImageData(base64ImageData);

            setTimeout(() => {
                setLoading(false);
                
            }, 2000);

        }
        else{
            setTimeout(() => {
                setLoading(false);
              }, 2000);

            // setErrorMessage(`Error: Failed to Generate Stock Image. generateReport`)
            //      setShowError(true)
            //       setLoading(false)
            //       setTimeout(() => {
            //         setShowError(true)
            //         setErrorMessage('')
      
            //       }, 2000);
           }

    };

    //  this function generae image when image is already not generarted on the stock name change
    const generateImage = async (stock, stockType, intervaltime) => {
        setLoading(true);
       
        console.log("insdie if of generte report");
        try{
        await fetch(`${BASE_URL}/getstockimage/${stock}/${stockType}/${intervaltime}`, {
            method: "GET", // or 'POST' or any other HTTP method
            headers: {
                Accept: "image/png",
            },
            responseType: "blob", // Set the responseType to 'blob'
        })
            .then((response) => response.arrayBuffer())
            .then((buffer) => {
                // console.log("buffer", typeof buffer,buffer)

                const blob = new Blob([buffer], { type: "image/png" });
                let imageurl = URL.createObjectURL(blob);
                setimageURL(imageurl);
                setImageGenerate(true)

                if (blob) {
                    const uint8Array = new Uint8Array(buffer);
                    const base64String = uint8Array.reduce(
                        (data, byte) => data + String.fromCharCode(byte),
                        ""
                    );
                    const ImageData = btoa(base64String);

                    setBase64ImageData(ImageData)

                  
                        setLoading(false);
                       

                    
                }else{
                    setErrorMessage(`Error: Failed to Generate Stock Image.`)
                    setShowError(true)
                     setLoading(false)
                     setTimeout(() => {
                       setShowError(true)
                       setErrorMessage('')
         
                     }, 2000);  
                }
            })
            .catch((error) => {
                console.error("Error fetching image:", error)
                setErrorMessage(`Error: ${error.message}`)
                            setShowError(true)
                             setLoading(false)
                             setTimeout(() => {
                               setShowError(true)
                               setErrorMessage('')
                 
                             }, 2000);
            });
        }catch(error){
            setErrorMessage(`Error: ${error.message}`)
                            setShowError(true)
                             setLoading(false)
                             setTimeout(() => {
                               setShowError(true)
                               setErrorMessage('')
                 
                             }, 2000);
        }
    }


    //  this fucntion is used to clear fill data and cancel the report generation
    const handleCancel = (event) => {
        event.preventDefault();
        // Reset main form state
        setEventForm({
            eventType: "Options", // Add other fields and their initial values as needed
        });
        setimageURL("");
        setImageName(null);
        setBase64ImageData("");
        setIsFormEditable(true);
        // Reset section states
        setFutureSectionState({
            futureReportType: "BUY",
            stockType: "",
            cashCMP: "",
            futureCMP: "",
            futureSL: 0,
            futureRemark: "",
            commentry: "",
            Expiry: "",
            imageData: "",
            base64Data: "",
            volume: '',
            lot_size: ''
        });


    };


    //  this fucntion is used to clear all field when report send to telegram form child component
    const handleEventChangeOfTelegram = (newvalue) => {
        console.log("inside handleEventChangeOfTelegram", newvalue)
        setLoading(true)
        setEventForm({ ...eventForm, eventType: "" });
        setIsFormEditable(true);
        setTimeout(() => {
            if (newvalue === "Future") {
                setEventForm({ ...eventForm, eventType: newvalue });
                setFutureSectionState({
                    futureReportType: "BUY",
                    stockType: "",
                    cashCMP: "",
                    futureCMP: "",
                    futureSL: '0',
                    futureRemark: "Please Note That Stop Loss is Zero, Please Calculate Risk Before Initiating Trade.",
                    commentry: "",
                    Expiry: "",
                    volume: '',
                    lot_size: ""
                });
      

                setimageURL("");
                setImageName(null);
                setBase64ImageData("");
                setChecked(true);
                setAlreadySubmit(false);
                setLoading(false)

            }

            
        }, 200);
        setLoading(false)


    };

    //  this  function is used to change telegram toggle send report or not
    const handleChange = (event) => {
        event.preventDefault();
        // console.log("event.target.checked", event.target.checked);
        setChecked(event.target.checked);
    };


    const IOSSwitch = styled((props) => (
        <Switch
            focusVisibleClassName=".Mui-focusVisible"
            disableRipple
            {...props}
        />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: 2,
            transitionDuration: "300ms",
            "&.Mui-checked": {
                transform: "translateX(16px)",
                color: "#fff",
                "& + .MuiSwitch-track": {
                    backgroundColor:
                        theme.palette.mode === "dark" ? "#2ECA45" : "#23499E",
                    opacity: 1,
                    border: 0,
                },
                "&.Mui-disabled + .MuiSwitch-track": {
                    opacity: 0.5,
                },
            },
            "&.Mui-focusVisible .MuiSwitch-thumb": {
                color: "#33cf4d",
                border: "6px solid #23499E",
            },
            "&.Mui-disabled .MuiSwitch-thumb": {
                color:
                    theme.palette.mode === "light"
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            "&.Mui-disabled + .MuiSwitch-track": {
                opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
            },
        },
        "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 22,
            height: 22,
        },
        "& .MuiSwitch-track": {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
            opacity: 1,
            transition: theme.transitions.create(["background-color"], {
                duration: 500,
            }),
        },
    }));


//   this fucntion is used to remove image from child compnent
    const handleRemoveFileFromChild = () => {

        setimageURL(null);
        setBase64ImageData("");
        setImageName(null);

    };

    //  this fucntion is used to change the selected stockloss from child component
    const handleStockLossRecordChange = (newRecord) => {
        setStockLossRecord(newRecord)
    }

    // this fucntion is used to paste the image
    const handlePaste = (e) => {
        e.preventDefault();
        const items = e.clipboardData.items;

        for (let i = 0; i < items.length; i++) {
            const item = items[i];

            if (item.type.indexOf('image') !== -1) {
                // e.preventDefault();
                const file = item.getAsFile();

                setImageName(file.name);
                const reader = new FileReader();
                reader.onloadend = () => {
                    // Handle the base64-encoded image
                    const base64Image = reader.result;
                    // Send the base64-encoded image to the backend using FormData or perform other actions
                    // console.log(base64Image);
                    setimageURL(base64Image);
                };

                reader.readAsDataURL(file);
            }
        }
    };

    // this function is used to change the image date using imageref
    const handleContentChange = () => {
        imageRef.current.contentEditable = true;
    };

    //  this function is called form child to manage whether form is editable or not
    const handleEditableFromReport = () => {

        setIsFormEditable(false);
    };

    return (
      
        <>
            <Sidebar />
            <div className="create-report">
                <Container fluid style={{ padding: "0 40px" }}>
                    {loading ? (
                        <div
                            style={{
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 2,
                            }}

                        >
                            <Loading />
                        </div>
                    ) : null}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <h2 class="create-report-heading">Create report</h2>
                        <h2 class="Preview-report-heading">Preview Screen</h2>
                    </div>
                    <div id="divcontent" className="divcontent">
                        

                        <form id="eventForm" className="eventForm">
                            <div className="options">
                                <div>
                                    
                                    <IOSSwitch
                                        sx={{ m: 1 }}
                                        defaultChecked
                                        checked={checked}
                                        onChange={handleChange}
                                        inputProps={{ "aria-label": "controlled" }}
                                    />
                                </div>
                            </div>
                            <div className="form-report">
                            
                                    <div id="futurebuyingDiv" className="future">
                                        <FutureSection
                                            stockSymbols={stockSymbols}
                                            requestToken={request_token}
                                            commenteryData={commenteryData}
                                            isEditable={isFormEditable}
                                            onFutureSectionChange={handleFutureSectionChange}
                                            onFutureExpirySelect={handleFutureExpirySelect}
                                            onFutureStockSelect={handleFutureStockSelect}
                                            onRemoveFile={handleRemoveFileFromChild}
                                            onStockLossRecord={handleStockLossRecordChange}
                                            generateImage={generateImage}
                                        />
                                    </div>
                             

                                
                                <div className="ReportImagePick" id="stockimageInputDiv">
                                    <p>Image:</p>
                                    <div
                                        className="Image-paste-box"
                                        ref={imageRef}

                                        contentEditable={imageName}
                                        onPaste={handlePaste}
                                        onInput={handleContentChange}

                                    >
                                        {imageName ? (
                                            <div>
                                                <p style={{ width: '100%' }}>Image Name: {imageName}</p>

                                            </div>
                                        ) : (
                                            <p style={{ width: '100%' }}>Paste an image here...</p>
                                        )}
                                    </div>
                                </div>


                               

                                <div className="btndiv">
                                    <button
                                        type="button"
                                        onClick={handleCancel}
                                        className="cancel-btn"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        onClick={submitForm}
                                        className="submit-btn"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                      
                        <div className="preview-screen">
                                <Report
                                    reportChecked={checked}
                                    eventType={"Future"}
                                    SectionState={futureSectionState}
                                    reportDate={reportDate}
                                    imageUrl={imageUrl}
                                    imageBuffer={base64ImageData}
                                    selectedExpiryRecord={FutureExpirySelected}
                                    selectedStockRecord={FutureStockSelected}
                                    setEventChange={handleEventChangeOfTelegram}
                                    stockLossRecord={stockLossRecord}
                                    onSuccessSubmit={handleEditableFromReport}
                                    isMCX={false}
                                />
                 

                           
                        </div>
               
              <TelegramWidget/>
                    </div>

                

                    <Dialog
                        open={errorDialog}
                        onClose={() => {
                            setErrorDialog(false);
                        }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                <div>
                                    {futureError ? (
                                        <span style={{ color: "black" }}>
                                            <span style={{ color: "red" }}>*</span> Please Fill All
                                            Mendatory Field.
                                        </span>
                                    ) : null}
                                   
                                    {ApiError ? (
                                        <span style={{ color: "black" }}>
                                            We're sorry, but something went wrong while processing
                                            your request.
                                        </span>
                                    ) : null}
                                </div>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>


                    <Dialog
                        open={showError}
                        onClose={() => {
                            setShowError(false);
                        }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                <div> 
                                
                                        <span style={{ color: "black" }}>
                                          {errorMessage}
                                        </span>
                                    
                                </div>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>

                </Container>
            </div>
        </>
   
    );
};

export default CreateReport;
